(function(){
"use strict";

const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
const form = () => document.querySelector(".product-form") || document.querySelector("product-form") || document.querySelector(".product__info-container");
// Cierre y barra fija: agregan al carrito con el botón del theme (un solo producto, sin packs)
document.addEventListener("click", e => {
  if (!e.target.closest(".lp [data-buy]")) return;
  const b = document.querySelector(".product-form__submit");
  if (b && !b.disabled) { b.click(); return; }
  const f = form(); if (f) f.scrollIntoView({behavior: reduce ? "auto" : "smooth", block: "center"});
});

// Despacho según la hora de Santiago
function despacho(){
  let h = 12;
  try { h = +new Intl.DateTimeFormat("es-CL", {timeZone:"America/Santiago", hour:"numeric", hourCycle:"h23"}).format(new Date()); } catch(e) {}
  const DIAS = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];
  let d = new Date();
  try { const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", {timeZone:"America/Santiago", year:"numeric", month:"numeric", day:"numeric"}).formatToParts(d).map(x => [x.type, x.value])); d = new Date(+p.year, +p.month - 1, +p.day); } catch(e) {}
  if (h >= 12) d.setDate(d.getDate() + 1);
  const txt = `Llega ${h < 12 ? "hoy" : "mañana"} ${DIAS[d.getDay()]} ${d.getDate()} (RM)`;
  document.querySelectorAll("[data-ship]").forEach(el => el.textContent = txt);
}
despacho(); setInterval(despacho, 60000);

// Barra fija: aparece solo cuando no hay otra compra a la vista
(function(){
  const bar = document.querySelector(".lp .sticky"); if (!bar) return;
  // Zonas = los botones de compra (no sus contenedores): la ficha del shaker sigue con acordeones bajo el botón y la
  // lámina final es alta, así que con los contenedores la barra quedaba oculta sin ninguna compra a la vista (20-10).
  const zones = () => [document.querySelector(".product-form__submit"), document.querySelector(".lp .final [data-buy]")].filter(Boolean);
  const update = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const hide = zones().some(z => { const r = z.getBoundingClientRect(); return r.bottom > 0 && r.top < vh - 40; });
    bar.classList.toggle("is-hidden", hide); bar.toggleAttribute("inert", hide);
  };
  addEventListener("scroll", update, {passive: true}); addEventListener("resize", update);
  addEventListener("load", update); setTimeout(update, 1200);
  update();
})();

// Galería propia: se mueve a la columna de fotos del theme y se arma el carrusel
(function(){
  const g = document.querySelector(".lp-galeria"), mw = document.querySelector(".product__media-wrapper");
  if (g && mw) { mw.prepend(g); document.documentElement.classList.add("lp-gal-ok"); }
  const tr = document.getElementById("track"); if (!tr) return;
  const slides = [...tr.children], n = slides.length;
  const dots = document.getElementById("dots"), th = document.getElementById("thumbs"), cnt = document.getElementById("gcount");
  dots.innerHTML = slides.map((s, i) => `<button class="dot" data-go-slide="${i}" aria-label="Ir a: ${s.dataset.name}"></button>`).join("");
  th.innerHTML = "";
  slides.forEach((s, i) => {
    const b = document.createElement("button"); b.className = "th"; b.dataset.goSlide = i; b.setAttribute("aria-label", "Ir a: " + s.dataset.name);
    const c = s.cloneNode(true); c.setAttribute("aria-hidden", "true"); c.removeAttribute("data-name");
    c.querySelectorAll("button").forEach(x => x.setAttribute("tabindex", "-1"));
    b.appendChild(c); th.appendChild(b);
  });
  const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : tr.clientWidth);
  const idx = () => Math.round(tr.scrollLeft / step());
  const mark = () => { const k = idx(); cnt.textContent = (k + 1) + " / " + n; document.querySelectorAll("[data-go-slide]").forEach(b => b.setAttribute("aria-current", +b.dataset.goSlide === k ? "true" : "false")); };
  const goS = k => { k = (k + n) % n; tr.scrollTo({left: k * step()}); };
  tr.addEventListener("scroll", mark, {passive:true});
  tr.addEventListener("keydown", e => { if (e.key === "ArrowRight") goS(idx() + 1); if (e.key === "ArrowLeft") goS(idx() - 1); });
  document.addEventListener("click", e => {
    const d = e.target.closest("[data-go-slide]"); if (d) { goS(+d.dataset.goSlide); return; }
    const g2 = e.target.closest("[data-gnav]"); if (g2) goS(idx() + +g2.dataset.gnav);
  });
  mark();
})();

})();
